export * from "modules/AppointmentDetails/components/DeskCommunication/components/CounterTabletModal";
export * from "modules/AppointmentDetails/components/DeskCommunication/components/DeskCommunicationModal";
